import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          name: Yup.string()
                                                   .required('Required'),
                                          pipelineType: Yup.string()
                                                           .required('Required'),
                                      });
